export const GET_ATTRIBUTES_REQUEST = Symbol('catalog/GET_ATTRIBUTES_REQUEST');

export const GET_ATTRIBUTES_SUCCESS = Symbol('catalog/GET_ATTRIBUTES_SUCCESS');

export const GET_ATTRIBUTES_FAILURE = Symbol('catalog/GET_ATTRIBUTES_FAILURE');

export const REPLACE_ATTRIBUTES = Symbol('catalog/REPLACE_ATTRIBUTES');
